import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import {
  WidgetCard,
  WidgetFooter,
  WidgetHint,
} from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { type HandOffActionWidgetStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/store/handOffActionWidgetStore.ts'
import { HandoffNotifyStep } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/steps/HandoffNotifyStep.tsx'
import { HandoffWhoNotifiedStep } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/steps/HandoffWhoNotifiedStep.tsx'
import { HandoffTriggerStep } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/steps/HandoffTriggerStep.tsx'

export const HandOffActionWidget = observer(({ store }: { store: HandOffActionWidgetStore }) => {
  const renderContent = () => {
    if (store.isNotifyStep) {
      return <HandoffNotifyStep store={store} />
    }
    if (store.isWhoNotifiedStep) {
      return <HandoffWhoNotifiedStep store={store} />
    }
    if (store.isTriggerStep) {
      return <HandoffTriggerStep store={store} />
    }
    return null
  }

  return (
    <>
      <WidgetCard header={store.currentHeader}>
        {renderContent()}
        <WidgetFooter
          step={store.step}
          total={store.totalSteps}
          onSkip={store.handleClose}
          onBack={store.step > 1 ? store.goBack : undefined}
          action={
            store.isNextStep ? (
              <IconButton
                icon={'arrowRight'}
                ariaLabel={'WidgetNext'}
                color={'primary'}
                onClick={store.onNext}
                disabled={store.isNextDisabled}
              />
            ) : store.isSubmitStep ? (
              <IconButton
                icon={'arrowUp'}
                ariaLabel={'WidgetSubmit'}
                color={'primary'}
                onClick={store.onSubmit}
                disabled={store.isSubmitDisabled}
              />
            ) : null
          }
        />
      </WidgetCard>
      <WidgetHint items={store.hint} />
    </>
  )
})
